import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import ReadingTime from './ReadingTime';
import s from './ByLine.scss';
var ByLine = function (_a) {
    var deviation = _a.deviation, withReadingTime = _a.withReadingTime, className = _a.className;
    var t = useTranslation().t;
    if (!withReadingTime && !deviation.poll) {
        return null;
    }
    return (React.createElement("div", { className: classnames(s['root'], className) },
        withReadingTime && React.createElement(ReadingTime, { deviation: deviation }),
        deviation.poll && (React.createElement("span", { className: s['votes'] }, t('pollView.votes', { count: deviation.poll.votes })))));
};
ByLine.displayName = 'ByLine';
export default ByLine;
//# sourceMappingURL=ByLine.js.map